import { action, payload } from 'ts-action'
import { IDocument } from 'models/Document'
import { IError, IPayload } from 'models/Global'

export const DocumentsFetching = action('DocumentsFetching', payload<boolean>())
export const RemoveFirstDocument = action('RemoveFirstDocument')
export const GetDocuments = action(
  'GetDocuments',
  payload<IPayload<IDocument[]>>(),
)
export const GetDocumentsErrors = action('GetDocumentsError', payload<IError>())
